import { render } from "./static-page-update.vue?vue&type=template&id=9ff3200e"
import script from "./static-page-update.vue?vue&type=script&lang=js"
export * from "./static-page-update.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__